import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyOtherSettingsServices = {
  //Table Properties
  updateTableProperties,
  updateTableIndexing,
  getTablePropertiesData,
  getGlobalTablePropertiesData,
};

// Get Table Properties
async function getGlobalTablePropertiesData(type) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getGlobalTablePropertiesData/${type}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Table Properties
async function getTablePropertiesData(type, studyId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getTablePropertiesData/${type}/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Update Table Properties
async function updateTableProperties(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateTableProperties`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  if(userData?.auto !== "yes"){
    handleResponse(data)
  }
  return data;
}

// Update Table Indexing
async function updateTableIndexing(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateTableIndexing`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}